import * as z from 'zod/mini'
import { DateTime } from 'luxon'
import { CANCELLATION_NEVER, endAfterStart, reservationFields, reservationTextFields } from '@seiri/shared/common'
import { CreateManagedReservationForm, EditReservationForm } from '../types/reservation-form.typs'

/**
 * The manual-reservation dialog. Every key is present so each binds to an input; an empty select is
 * `''`, which `toCreateManagedReservationBody` leaves out of the body. The name rule and the
 * end-after-start rule are the API's.
 */
export type ManagedReservationFormModel = Required<CreateManagedReservationForm>

export const managedReservationFormModel = z
  .object({
    name: reservationFields.name,
    start: z.date(),
    end: z.date(),
    activityId: z.nullable(z.string()),
    placeId: z.nullable(z.string()),
    employeeIds: z.array(z.string()),
    customerId: z.nullable(z.string()),
    description: reservationTextFields.description,
    notifyCustomer: z.boolean(),
    cancellationDeadline: reservationFields.cancellationDeadline,
  })
  .check(z.superRefine(endAfterStart('start', 'end')))

export const emptyManagedReservationFormModel = (): ManagedReservationFormModel => ({
  name: '',
  start: DateTime.now().startOf('hour').plus({ minutes: 30 }).toJSDate(),
  end: DateTime.now().startOf('hour').plus({ hours: 1 }).toJSDate(),
  activityId: '',
  placeId: '',
  employeeIds: [],
  customerId: '',
  description: '',
  notifyCustomer: false,
  cancellationDeadline: CANCELLATION_NEVER,
})

/** The edit dialog: the API's rules for name, time and description. */
export type EditReservationFormModel = EditReservationForm

export const editReservationFormModel = z
  .object({
    name: reservationFields.name,
    start: z.date(),
    end: z.date(),
    activityId: z.nullable(z.string()),
    placeId: z.nullable(z.string()),
    employeeIds: z.array(z.string()),
    description: reservationTextFields.description,
    notifyCustomer: z.boolean(),
  })
  .check(z.superRefine(endAfterStart('start', 'end')))
